import { useEffect } from "react";
import * as yup from "yup";
import { FormikConfig, FormikValues, useFormik } from "formik";
import { Toast, TABS_QUERY_NAME } from "@techzyapp/ui-lib";
import { supportedLanguages } from "./useTranslation";

function useForm<Values extends FormikValues = FormikValues>(
  config: FormikConfig<Values>
) {
  const form = useFormik(config);

  useEffect(() => {
    valdiate(form.values);
  }, [form.submitCount]);

  function valdiate(values: Values) {
    try {
      config.validationSchema.validateSync(values, {
        abortEarly: false,
      });
    } catch (validationError) {
      if (validationError instanceof yup.ValidationError) {
        const currentLanguageCode = new URLSearchParams(
          window.location.search
        ).get(TABS_QUERY_NAME);
        if (
          !currentLanguageCode ||
          !supportedLanguages.includes(currentLanguageCode)
        ) {
          return;
        }
        const showError =
          validationError.inner?.length > 0 &&
          validationError.inner.filter((error) =>
            error?.path?.includes("translations")
          )?.length > 0 &&
          validationError.inner
            .filter((error) => error?.path?.includes("translations"))
            .every(
              (error) =>
                error.path && !error?.path?.includes(currentLanguageCode)
            );

        showError &&
          Toast.warning(
            validationError.inner.filter((error) =>
              error.path?.includes("translations")
            )[0].message + " for every language"
          );
      }
    }
  }

  return form;
}

export default useForm;
